import { useContext, useMemo } from 'react';

import { useGetBanditHeadlineText } from '../bandits';

import { ShareHeadlineContext } from './context';
import type { ShareHeadline } from './types';

type Result = Pick<ShareHeadline, 'title' | 'description'> & { imageUrl?: string };

export function useShareHeadline(): Result | undefined {
	const context = useContext(ShareHeadlineContext);
	const getBanditHeadlineText = useGetBanditHeadlineText(context?.sharer);

	return useMemo(() => {
		if (!context) return undefined;
		if (context.previewLink) {
			const hasImage = context.previewLink.images.length > 0;
			return {
				title: context.previewLink.title,
				description: '',
				imageUrl: hasImage ? context.previewLink.images[0].url : undefined,
			};
		}
		return {
			title: getBanditHeadlineText(context.title) || '',
			description: getBanditHeadlineText(context.description) || '',
		};
	}, [context, getBanditHeadlineText]);
}
